var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.818,
    height: 31.231,
    viewBox: "0 0 27.818 31.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M212.812,85.384l2.294-3.892,6.182,9.629,0,1.848-.02-12.716a.958.958,0,0,0-.443-.763l-11.13-6.4a.981.981,0,0,0-.85,0,.965.965,0,0,0-.1.058l-.039.024-10.8,6.261-.042.019a.983.983,0,0,0-.16.093.955.955,0,0,0-.385.608.985.985,0,0,0-.014.112l.017,10.362L203.08,81.7c.725-1.184,2.3-1.565,3.771-1.544l1.721.045-10.14,16.262,1.2.688,10.262-16.934,4.536-.016L204.189,97.567l4.265,2.453.51.293a.979.979,0,0,0,.687.014l11.287-6.541-2.158,1.25Zm.875,12.6-4.308-6.761,2.63-4.462,5.658,8.918Z",
    transform: "translate(-195.385 -71.074)",
    fill: "#2d374b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M321.883,219.535l4.308,6.761,3.98-2.306-5.658-8.918Z",
    transform: "translate(-307.888 -199.384)",
    fill: "#28a0f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M365.782,172.161l0-1.848-6.182-9.629-2.294,3.892,5.968,9.652,2.158-1.25a.956.956,0,0,0,.353-.7Z",
    transform: "translate(-339.875 -150.266)",
    fill: "#28a0f0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M177.491,161.481l3.047,1.756,10.14-16.262-1.721-.045c-1.466-.021-3.046.36-3.771,1.544l-5.758,8.925-1.937,2.977v1.106Z",
    transform: "translate(-177.491 -137.844)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M236.063,147.406l-4.536.016-10.262,16.934,3.587,2.065.975-1.654Z",
    transform: "translate(-217.023 -138.275)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M205.309,62.3a2.889,2.889,0,0,0-1.356-2.323l-11.276-6.484a2.933,2.933,0,0,0-2.587,0c-.094.047-10.966,6.353-10.966,6.353a2.9,2.9,0,0,0-.432.256,2.867,2.867,0,0,0-1.2,2.193V75.725l1.937-2.977-.017-10.362a.963.963,0,0,1,.4-.72c.051-.037,11.108-6.437,11.143-6.455a.981.981,0,0,1,.85,0l11.13,6.4a.958.958,0,0,1,.443.763V75.209a.936.936,0,0,1-.333.7l-2.158,1.25-1.113.645-3.98,2.306-4.036,2.339a.978.978,0,0,1-.687-.014L186.3,79.686l-.975,1.654,4.291,2.471.372.211c.161.09.27.15.309.169a2.788,2.788,0,0,0,1.139.234,2.869,2.869,0,0,0,1.051-.2l11.722-6.789a2.866,2.866,0,0,0,1.1-2.159Z",
    transform: "translate(-177.492 -53.194)",
    fill: "#96bedc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArb);
export default __webpack_public_path__ + "static/media/arb.a8b097224e4ef459069bf8dd54e81339.svg";
export { ForwardRef as ReactComponent };